import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';

import { FeatureCtaContainer } from 'containers/common/app/feature-cta-container';
import { FaqContainer } from 'containers/common/components/faq/faq-container';
import { IncognitoModeBlockOneContainer } from 'containers/features/incognito-mode/incognito-mode-block-one-container';
import { IncognitoModeBlockThreeContainer } from 'containers/features/incognito-mode/incognito-mode-block-three-container';
import { IncognitoModeBlockTwoContainer } from 'containers/features/incognito-mode/incognito-mode-block-two-container';
import { IncognitoModeHeroBlockContainer } from 'containers/features/incognito-mode/incognito-mode-hero-block-container';
import { PageContainer } from 'containers/page/page-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

const faqContent = () => [
  {
    question: features.incognitoMode.lxIncognitoModeFaqQuestionOneTitle,
    answer: features.incognitoMode.lxIncognitoModeFaqQuestionOneAnswer,
  },
  {
    question: features.incognitoMode.lxIncognitoModeFaqQuestionTwoTitle,
    answer: features.incognitoMode.lxIncognitoModeFaqQuestionTwoAnswer,
  },
  {
    question: features.incognitoMode.lxIncognitoModeFaqQuestionThreeTitle,
    answer: features.incognitoMode.lxIncognitoModeFaqQuestionThreeAnswer,
  },
];

export const IncognitoModeContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <IncognitoModeHeroBlockContainer />
        <IncognitoModeBlockOneContainer />
        <IncognitoModeBlockTwoContainer />
        <IncognitoModeBlockThreeContainer />
        <FaqContainer title={features.incognitoMode.lxFeaturesFaqTitle} content={faqContent()} />
        <FeatureCtaContainer title={features.incognitoMode.lxIncognitoModeBrowsePrivatelyText} />
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
